
const services = [
  {
    icon: 'ri-shield-check-line',
    title: 'Milli Tesis Güvenlik Belgesi',
    description: 'MSB tarafından verilen Milli Tesis Güvenlik Belgesi ile gizlilik dereceli savunma sanayi projelerine katılım hakkı kazanın.',
    link: '/hizmetler/milli-tgb'
  },
  {
    icon: 'ri-global-line',
    title: 'NATO Tesis Güvenlik Belgesi',
    description: 'NATO gizlilik dereceli bilgilere erişim ve uluslararası savunma projelerinde yer almak için NATO TGB danışmanlığı.',
    link: '/hizmetler/nato-tgb'
  },
  {
    icon: 'ri-building-2-line',
    title: 'Özel Tesis Güvenlik Belgesi',
    description: 'Özel sektör savunma sanayi projeleri için gerekli güvenlik standartlarını karşılayan tesis belgesi alma süreçleri.',
    link: '/hizmetler/ozel-tgb'
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Belge Yenileme ve Süre Uzatma',
    description: 'Mevcut tesis güvenlik belgelerinizin yenileme ve süre uzatma işlemlerinde profesyonel danışmanlık desteği.',
    link: '/hizmetler/belge-yenileme'
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Fiziki Güvenlik ve Altyapı',
    description: 'CCTV, alarm sistemleri, erişim kontrol ve fiziki güvenlik altyapısı kurulumu konusunda teknik danışmanlık.',
    link: '/hizmetler/fiziki-guvenlik'
  },
  {
    icon: 'ri-user-search-line',
    title: 'Personel Güvenlik Soruşturması',
    description: 'Gizlilik dereceli bilgilere erişecek personel için güvenlik soruşturması süreçlerinde rehberlik ve danışmanlık.',
    link: '/hizmetler/personel-guvenlik-sorusturmasi'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider mb-3">
            Hizmetlerimiz
          </p>
          <h2 className="font-serif text-5xl font-bold text-gray-900 mb-6">
            Tesis Güvenlik Belgesi Danışmanlığı
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            MSB ve NATO tesis güvenlik belgesi süreçlerinde başvurudan belge teslimine kadar uçtan uca profesyonel danışmanlık hizmeti sunuyoruz.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6 group-hover:bg-orange-500 transition-colors">
                <i className={`${service.icon} text-3xl text-orange-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
              <a href={service.link} className="text-orange-500 font-semibold inline-flex items-center gap-2 cursor-pointer hover:gap-3 transition-all whitespace-nowrap">
                Detaylı Bilgi
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
